import Vue from 'vue'
import VueRouter from 'vue-router'
import Auth from '@aws-amplify/auth';
import Home from './views/Home.vue'
import store from './store';
import SelectEnterpriseView from './views/SelectEnterpriseView.vue';
import ResetPasswordView from './views/ResetPwdView.vue';
import ChangeTmpPwdView from './views/ChangeTmpPwdView.vue';
import LoginView from './views/LoginView.vue';
import { AWSEventBus } from '@bag-era/cognito-authentication';

Vue.use(VueRouter)

const router =  new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: { name: 'Login' },
    },
    {
      path: '',
      redirect: { name: 'Login' },
    },
    {
      path: '/selectenterprise',
      name: 'selectenterprise',
      component: SelectEnterpriseView,
      meta: { requiresUser: false, requiresEnterprise: false },
    },
    {
      path: '/login',
      name: 'Login',
      component: LoginView,
      meta: { requiresUser: false, requiresEnterprise: true },
    },
    {
      path: '/resetpwd',
      name: 'resetpwd',
      component: ResetPasswordView,
      meta: { requiresUser: false, requiresEnterprise: true },
    },
    {
      path: '/changepwd',
      name: 'changepwd',
      component: ChangeTmpPwdView,
      meta: { requiresUser: false, requiresEnterprise: false },
    },
    {
      path: '/home',
      name: 'home',
      component: Home,
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/about',
      name: 'about',
      // route level code-splitting
      // this generates a separate chunk (about.[hash].js) for this route
      // which is lazy-loaded when the route is visited.
      component: () => import(/* webpackChunkName: "about" */ './views/About.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/of/details/:id',
      name: 'manufacturing-order-details',
      component: () => import('./views/MoDetails.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/of/create',
      name: 'create of',
      component: () => import('./views/OfCreate.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/of/duplicate/:id',
      name: 'duplicate of',
      component: () => import('./views/OfCreate.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/of/edit/:id',
      name: 'edit of',
      component: () => import('./views/OfCreate.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/production-area',
      name: 'production-zone',
      component: () => import('./views/ProductionArea.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/pz/details/:id',
      name: 'production-zone-details',
      component: () => import('./views/ZpDetails.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/operators',
      name: 'operators',
      component: () => import('./views/Operators.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/products',
      name: 'products',
      component: () => import('./views/Products.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
    {
      path: '/beacons',
      name: 'beacons',
      component: () => import('./views/Beacons.vue'),
      meta: { requiresUser: true, requiresEnterprise: true },
    },
  ]
})

router.beforeResolve(async (to, from, next) => {
  const enterprise = store.getters.enterprise;
  const user = store.getters.cognitoUser;
  
  if (to.matched.some((record) => record.meta.requiresEnterprise)) {
    if (!enterprise) {
      return next({
        path: '/selectenterprise',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
  if (to.matched.some((record) => record.meta.requiresUser)) {
    if (!user) {
      return next({
        path: '/login',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  } else if (to.path === '/login') {
    if (user) {
      return next({
        path: '/home',
        query: {
          redirect: to.fullPath,
        },
      });
    }
  }
  return next();
});

AWSEventBus.$on('loggedIn', async (data) => {
  console.log("logged")
  const user = {
    username: data.username,
    Session: data.Session,
    info: data.signInUserSession.idToken.payload,
  };
  store.dispatch('setUser', user);
  router.push('/home');
});

AWSEventBus.$on('resetPassword', async (data) => {
  console.log("reset");
  router.push({ path: '/resetpwd', query: { username: data.username } });
});

AWSEventBus.$on('pwdChanged', async () => {
  router.push({ path: '/login' });
});

AWSEventBus.$on('changeTmpPassword', async (data) => {
  router.push({ path: '/changepwd', query: { username: data.username, password: data.password } });
});

AWSEventBus.$on('selectEnterprise', async () => {
  const enterprise = store.getters.enterprise;
  const awsExports = {
    aws_project_region: enterprise.poolInfo.region,
    aws_cognito_region: enterprise.poolInfo.region,
    aws_user_pools_id: enterprise.poolInfo.userPoolId,
    aws_user_pools_web_client_id: enterprise.poolInfo.clientId,
  };
  Auth.configure(awsExports);
  router.push({ path: '/login' });
});

AWSEventBus.$on('loggedOut', async () => {
  store.dispatch('setUser', null);
  router.push({ path: '/login' });
});

AWSEventBus.$on('changeEnterprise', async () => {
  store.dispatch('setEnterprise', null);
  Auth.configure({});
  router.push({ path: '/selectenterprise' });
});

export default router;